import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { AppState } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { UserCategory } from 'src/app/core/models/core.models';
import { toggleUserCategorySelection } from 'src/app/core/actions/post.actions';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CategoryComponent {
  @Input() category!: UserCategory;
  @Input() categoryForm!: FormGroup;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {}

  get isSelectedControl(): FormControl {
    return this.categoryForm.get('isSelected') as FormControl;
  }

  onCheckboxChange(isSelected: boolean) {
    this.store.dispatch(
      toggleUserCategorySelection({
        companyCategoryId: this.category.company_category_id,
        categoryId: this.category.id,
        selected: isSelected,
      }),
    );
    // Additional logic if needed when a checkbox changes
    this.categoryForm.markAsDirty();
  }
}
